// extracted by mini-css-extract-plugin
export default {"experiences__frame":"Experiences_experiences__frame__KZsz0"};